import { MessageSquare } from 'lucide-react';

/**
 * A product's comments, from its row: unread across its threads as a badge,
 * else how many messages there are. Always shown — starting a thread is a
 * reason to press it too.
 */
export function ProductCommentsButton({
	unread,
	count,
	unreadIn = [],
	onClick,
}: {
	unread: number;
	count: number;
	/** Where the unread messages are — "Patrick Vetter", "Studio notes". */
	unreadIn?: { label: string; unread: number }[];
	onClick: () => void;
}) {
	// Says where, not just how many: "2 new from Patrick Vetter · 1 in Studio notes".
	const where = unreadIn
		.map((t) =>
			t.label === 'Studio notes'
				? `${t.unread} new in Studio notes`
				: `${t.unread} new from ${t.label}`
		)
		.join(' · ');
	const label =
		unread > 0 ? where || `${unread} unread` : count > 0 ? `${count} messages` : 'Comments';

	return (
		<button
			type="button"
			onClick={onClick}
			title={label}
			aria-label={label}
			className="relative flex h-7 cursor-pointer items-center gap-1 rounded-md px-1.5 text-text-3 transition-colors hover:bg-surface-hover hover:text-text-1"
		>
			<MessageSquare size={14} />
			{unread > 0 ? (
				<span className="flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-2xs font-medium text-primary-foreground">
					{unread > 9 ? '9+' : unread}
				</span>
			) : (
				count > 0 && <span className="text-xs">{count}</span>
			)}
		</button>
	);
}
